// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__sk3RL","containerItemsCenter":"Skeleton_containerItemsCenter__3mOGb"};